var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8572 2V15.7143H38.5715",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 18H13.4285H11.1428",
    stroke: "#2667FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2857 27.1428H15.7143H11.1428",
    stroke: "#2667FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 36.2856H13.4285H11.1428",
    stroke: "#2667FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5714 22.5714V15.7143L24.8571 2H6.57143C5.35901 2 4.19625 2.48163 3.33894 3.33894C2.48163 4.19625 2 5.35901 2 6.57143V43.1429C2 44.3553 2.48163 45.518 3.33894 46.3753C4.19625 47.2327 5.35901 47.7143 6.57143 47.7143H19.1429",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7287 38.5714C43.7287 43.9443 39.373 48.3 34.0001 48.3C28.6272 48.3 24.2715 43.9443 24.2715 38.5714C24.2715 33.1985 28.6272 28.8428 34.0001 28.8428C39.373 28.8428 43.7287 33.1985 43.7287 38.5714Z",
    stroke: "#2667FF",
    strokeWidth: 3.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33.4346V38.5714L37.4286 42",
    stroke: "#2667FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/Notice.ff76e1dd09b6db660789d86c480e41bf.svg";
export { ForwardRef as ReactComponent };